import { render, staticRenderFns } from "./ImportNetlinks.vue?vue&type=template&id=63fbd917"
import script from "./ImportNetlinks.vue?vue&type=script&lang=js"
export * from "./ImportNetlinks.vue?vue&type=script&lang=js"
import style0 from "./ImportNetlinks.vue?vue&type=style&index=0&id=63fbd917&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports